import { screen } from 'components/styles/variables';

interface ButtonProps {
  label?: string;
  onClick?: () => void;
  type?: string;
  className?: string;
}

const Button = ({ label, onClick, type, className = '' }: ButtonProps): JSX.Element => (
  <button data-search-button-type={type} onClick={onClick} className={className}>
    {label}
    <style jsx>{`
      button {
        border: solid 2px white;
        color: white;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        text-transform: capitalize;
        cursor: pointer;
        text-align: center;
        padding: 13px;
        background-color: transparent;
        width: 180px;
        margin-top: 14px;
      }

      @media (min-width: ${screen.smMin}) {
        button {
          margin-left: auto;
          margin-right: auto;
          width: 100%;
          font-size: 18px;
        }
      }

      button:first-of-type {
        margin-top: 0;
      }

      button:hover {
        background-color: rgba(255, 255, 255, 0.22);
      }
    `}</style>
  </button>
);

export default Button;
